import React, { useEffect } from "react";
import Login from "../../components/login/Login"; //Include Login
import Signup from "../signup/Signup";
import Forgotpassword from "../Forgotpassword/Forgotpassword";
import { Details } from "../details/Details"; //Include Login
import PrivateRoute from "./Privateroute";
import { useLocation, useNavigate } from "react-router-dom";
import { withRouter } from "../../Helpers/Common";
import { Routes, Route, } from "react-router-dom";
import { NotFound } from "../PageNotFound/NotFound";
import { Demo } from "../Demo/demo";
import LoginTelebirr from "../subscribe/LoginTelebirr";

const Routestree = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname == "/login") {
      navigate("/");
    }
  }, [])
  let arrRoute = [
    "/",
    // "/about-us-m",
    // "/terms-m",
    // "/privacy-m",
    // "/help-support-m",
    // "/news-m",
    // "/faqs",
    // "/getstarted/",
    // "/exploreplan",
    // "/become-a-member",
    // "/select-topics",
    "/search/:docutype",
    "/movies",
    "/series",
    "/docubyteplay",
    "/docubyteplaytest",
    "/DocubytesSwiper",
    "/profile",
    // "/generatepin",
    "/manage-profile",
    "/manage-membership",
    // "/change-email",
    // "/change-mobile",
    // "/verify-email",
    // "/verify-mobile",
    // "/add-email",
    // "/add-mobile",
    "/baypage/:content_slug",
    "/faq",
    "/privacy",
    "/terms",
    "/about-us",
    // "/live-tv",
    // "/add-name",
    // "/change-name",
    // "/change-password",
    // "/manage-devices",
    "/watch-list",
    // "/cancel-payment",
    // "/success-payment",
    "/news",
    "/contact-us",
    // "/activate",
    "/docubytes-show",
    "/watchtrailer/:content_slug",
    "/playcontent/:content_slug",
    // "/playlive",
    // "/Getstarted",
    // "/ExplorePlan",
    "/paytmqrgeneration",
    "/subscription"
  ];

  return (
    <>
      <PrivateRoute />
      <Routes>
        <Route exact path="/login" element={<Login />} />
        <Route exact path="/createaccount" element={<Signup />} />
        <Route exact path="/subscribe" element={<LoginTelebirr />} />
        <Route exact path="/forgot-password" element={<Forgotpassword />} />
        <Route exact path="/QZPU7ApimV" element={<Demo />} />
        {arrRoute.includes(location.pathname) ? null : (
          <Route exact path="/:content_slug" element={<Details />} />
        )}
        <Route exact path="/404" element={<NotFound />} />
      </Routes>
    </>
  );
};
export default withRouter(Routestree);
